import { AxiosResponse } from 'axios';
import { call, put, all, takeEvery, takeLatest } from 'redux-saga/effects';

import {
  GET_EMPLOYERS,
  GET_EMPLOYERS_SUCCESS,
  GET_EMPLOYERS_ERROR,
  GET_EMPLOYES_PER_PAGE,
  GET_EMPLOYER_JOBS_PER_PAGE,
  GET_EMPLOYER_JOBS,
  GET_EMPLOYER_SUCCESS,
  GET_EMPLOYER_ERROR,
  GET_EMPLOYER,
  GET_EMPLOYER_JOBS_SUCCESS,
  GET_EMPLOYER_JOBS_ERROR
} from './constants';

import { getEmployersService, getEmployerJobsService, getEmployerService } from './services';

function* getEmployersFlow(action: any) {
  const {page, search} = action;
  try {
    const response:AxiosResponse = yield call(getEmployersService, page, GET_EMPLOYES_PER_PAGE, search);
    yield put({type: GET_EMPLOYERS_SUCCESS, response});
  } catch (error) {
    yield put({type: GET_EMPLOYERS_ERROR, error});
  }
}

function* getEmployerFlow(action: any) {
  const {companySlug} = action;
  try {
    const response: AxiosResponse = yield call(getEmployerService, companySlug);
    yield put({type: GET_EMPLOYER_SUCCESS, response});
  } catch (error) {
    yield put({type: GET_EMPLOYER_ERROR, error});
  }
}

function* getEmployerJobsFlow(action: any) {
  const {page, id, filter, searchParams} = action;
  try {
    const response: AxiosResponse = yield call(getEmployerJobsService, page, GET_EMPLOYER_JOBS_PER_PAGE, id, filter, searchParams);
    //const searchObject = queryString.parse(searchParams);
    yield put({type: GET_EMPLOYER_JOBS_SUCCESS, response});
  } catch (error) {
    yield put({type: GET_EMPLOYER_JOBS_ERROR, error});
  }
}

export default function* employersSaga() {
    yield all([
      takeLatest(GET_EMPLOYERS, getEmployersFlow),
      takeEvery(GET_EMPLOYER, getEmployerFlow),
      takeEvery(GET_EMPLOYER_JOBS, getEmployerJobsFlow),
    ])
}



